import {
  Component,
  Input,
  ViewEncapsulation,
  forwardRef,
  Output,
  EventEmitter,
  OnInit,
  ElementRef,
  Renderer2
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    selector: 'tidy-search-input',
    templateUrl: 'search-input.html',
    styleUrls: ['./search-input.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SearchInputComponent implements ControlValueAccessor, OnInit {

  @Input() placeholder = 'Search...';
  @Input() icon = 'assets/svg/search.svg';
  @Input() fixedWidth = true;
  @Input() backgroundColor = '#1A1C1F';
  @Output() valueChange = new EventEmitter<string>();

  value = '';
  isInputEmpty = true;
  onChange: any = () => {
    // ControlValueAccessor callback
  };
  onTouched: any = () => {
    // ControlValueAccessor callback
  };

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    const isSecondaryLayer = localStorage.getItem('isPrimaryLayer') === 'false' && this.windowService.isDesktopRes;
    if (isSecondaryLayer) {
      this.renderer.addClass(this.el.nativeElement, 'secondary-layer');
      this.backgroundColor = '#2A2C33';
    }
  }

  private hexToRgb(hex: string): { r: number; g: number; b: number } {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : { r: 255, g: 255, b: 255 };
  }

  private rgbToHex(r: number, g: number, b: number): string {
    return `#${  [r, g, b].map(x => {
      const hex = Math.round(x).toString(16);
      return hex.length === 1 ? `0${  hex}` : hex;
    }).join('')}`;
  }

  getBackgroundWithOpacity(): { [key: string]: string } {
    const rgb = this.hexToRgb(this.backgroundColor);
    // Mix with 20% white (255, 255, 255)
    const mixAmount = 0.05;
    const r = rgb.r + (255 - rgb.r) * mixAmount;
    const g = rgb.g + (255 - rgb.g) * mixAmount;
    const b = rgb.b + (255 - rgb.b) * mixAmount;
    return {
      'background-color': this.rgbToHex(r, g, b)
    };
  }

  writeValue(value: string): void {
    this.value = value;
    this.isInputEmpty = !value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(value: string): void {
    this.value = value;
    this.isInputEmpty = !value;
    this.onChange(value);
    this.onTouched();
    this.valueChange.emit(value);
  }

  clearInput(): void {
    this.value = '';
    this.isInputEmpty = true;
    this.onChange('');
    this.onTouched();
    this.valueChange.emit('');
  }
}
